class TextFieldController {

    $onInit() {
        this.required = this.required === undefined ? false : this.required;
        this.type = this.type || 'text';
    }

}

export default TextFieldController;


// WEBPACK FOOTER //
// ./app/common/form-fields/text-field/text-field-controller.js